import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsSection } from "@/features/dashboard/IntegrationsSection";

export const Route = createFileRoute("/_auth/_agents/settings/connectors")({
  component: IntegrationsSection,
});
